import axios from 'axios'

const curadorias = {}

curadorias.find = () => axios.get('/curadoria')
curadorias.findByTree = () => axios.get('/curadoria/ativos_em_arvore')

export { curadorias }
